const DASH = '—';

export const formatTRY = (value, { decimals = 0 } = {}) => {
  if (value === null || value === undefined || Number.isNaN(value)) return DASH;
  const fmt = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${fmt.format(value)} ₺`;
};

export const formatCompact = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return DASH;
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (abs >= 1_000_000) return `${sign}${(abs / 1_000_000).toLocaleString('tr-TR', { maximumFractionDigits: 1 })}M`;
  if (abs >= 1_000) return `${sign}${Math.round(abs / 1_000)}k`;
  return `${sign}${abs}`;
};

// Para OLMAYAN sayılar (miktar, adet, yüzde gövdesi) için tr-TR formatı.
// minDecimals verilmezse decimals'a eşitlenir (sabit hane); bare
// toLocaleString('tr-TR') parity'si için {decimals: 3, minDecimals: 0} kullan.
export const formatSayi = (value, { decimals = 2, minDecimals } = {}) => {
  if (value === null || value === undefined || Number.isNaN(value)) return DASH;
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: minDecimals === undefined ? decimals : minDecimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatPct = (value, { withSign = false, decimals = 1 } = {}) => {
  if (value === null || value === undefined || Number.isNaN(value)) return DASH;
  const fmt = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  if (withSign) {
    const prefix = value > 0 ? '+' : value < 0 ? '-' : '';
    return `${prefix}%${fmt.format(Math.abs(value))}`;
  }
  return `%${fmt.format(value)}`;
};

export const deltaOf = (current, previous) => {
  if (previous === null || previous === undefined || previous === 0) return null;
  return ((current - previous) / previous) * 100;
};
